import React, { useCallback, useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { Card } from 'components';
import DashboardServices from 'services/DashboardServices';
import IncidentStatusCount from './IncidentStatusCount';
import { useTheme } from '@mui/material/styles';
const Dashboard = ({ filters }) => {
const theme = useTheme();
    const [loaded, setLoaded] = useState(false)
    const [data, setData] = useState({
        today: 0,
        yesterday: 0,
        this_week: 0,
        last_week: 0,
        this_month: 0,
        last_month: 0,
        this_year: 0,
        last_year: 0
    })

    const getData = useCallback(async () => {
        setLoaded(false)
        const response = await DashboardServices.getIncidetSummary(filters);
        if (response.success) {
            setData(response?.data || {});
            setLoaded(true)
        }

    }, [filters]);

    useEffect(() => {
        getData();
    }, [getData]);



    const containerStyle = {
        //background: 'linear-gradient(135deg, #a18cd1, #fbc2eb)',
        borderRadius: '8px',
        // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',


    };

    const styles = {
        partOfContent: {
            marginTop: "10px",
            // background: 'linear-gradient(135deg, #a18cd1, #fbc2eb)',
            borderStyle: 'solid', borderWidth: '2px', borderColor: 'rgba(246, 246, 246, 0.9)'
        },
        title: {
            fontSize: '20px', color: theme.palette.text.primary
        },
        count: {
            fontSize: '24px', color: theme.palette.text.primary
        }
    }


    const renderComparison = (title, current, before) => {
        // Calculate percentage difference
        const percentageDiff = ((Number(current) - Number(before)) / Number(before) * 100).toFixed(2);
        // Determine arrow based on comparison
        const arrow = current > before ? '↑' : current < before ? '↓' : '';

        return (
            <div className='w-full'>
                <Grid container>
                    <Grid className='align-content-center' size={{ xs: 6 }} >
                        <div className='align-content-center' style={styles.title}>{title}</div>
                    </Grid>
                    <Grid className='align-content-center' size={{ xs: 3 }} >
                        <Typography variant='h6' style={styles.count}> {current} </Typography>
                    </Grid>
                    <Grid className='align-content-center' size={{ xs: 3 }} >
                        <div className='align-content-center flex w-full' >
                            <div>{arrow}</div>
                            <div> {before === 0 ? "0" : `${percentageDiff}%`}</div>
                        </div>

                    </Grid>
                </Grid>


            </div>
        );
    };

    return (
        <Card className="p-4" style={containerStyle}>
            <Typography variant='h6'>Incidents</Typography>
            <div className='mt-3'></div>

            {loaded &&
                <IncidentStatusCount filters={filters} />
            }
            <div className='px-2 border-radius-8'
                style={{
                    ...styles.partOfContent,
                    //background: 'linear-gradient(135deg, #822ae5, #a56dec)',
                    //boxShadow: '0 4px 8px rgba(130, 42, 229, 0.3)' // Shadow with #822ae5 and 30% opacity
                }}>
                {renderComparison("Today", data.today, data.yesterday)}

            </div>

            <div className='px-2 border-radius-8'
                style={{
                    ...styles.partOfContent,
                    // background: 'linear-gradient(135deg, #f2823b, #f5a671)',
                    //boxShadow: '0 4px 8px rgba(232,144,78, 0.3)' // Shadow with #822ae5 and 30% opacity
                }}>
                {renderComparison("This Week", data.this_week, data.last_week)}

            </div>

            <div className='px-2 border-radius-8'
                style={{
                    ...styles.partOfContent,
                    //background: 'linear-gradient(135deg, #5d81ff, #7b9cff)',
                    // boxShadow: '0 4px 8px rgba(42, 48, 229, 0.3)' // Shadow with #822ae5 and 30% opacity

                }}>
                {renderComparison("This Month", data.this_month, data.last_month)}

            </div>

            <div className='px-2 border-radius-8'
                style={{
                    ...styles.partOfContent,
                    //background: 'linear-gradient(135deg, #5ac520, #86e160)',
                    //boxShadow: '0 4px 8px rgba(86, 224, 0, 0.3)' // Shadow with #822ae5 and 30% opacity
                }}>
                {renderComparison("This Year", data.this_year, data.last_year)}

            </div>
        </Card>
    );
};

export default Dashboard;